
import './App.css';
import React from 'react';
import MatchButton from './MatchButton';
import SearchInput from './SearchInput';
import fireworks from './assets/images/Fireworks1.gif';
import huh from './assets/images/Huh1.gif';
import UpDownIndicator from './UpDownIndicator';
import MatchListContainer from './MatchListContainer';

class App extends React.Component {
  state = {
    leftIDSelected: null,
    rightIDSelected: null,
    matchButtonActive: false,
    matchedResults: [],
    displayMatchList: false,
    matchList: [],
    displaySameMovieList: false,
    sameMovieList: [],
    showFireworks: false,
    showHuh: false,
    leftNameSelected: '',
    rightNameSelected: '',
    showTagline: false,
    siteStatus: "Pending"
  };

  DBAliveTimeout = null;

  DBAlive = async () => {
    if (this.state.siteStatus !== "Up") {
      this.setState({ siteStatus: "Pending" });
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/DBAlive`);
      if (response.status === 500) {
        this.setState({ siteStatus: "Down" });
        this.DBAliveTimeout = setTimeout(this.DBAlive, 30000);  // Retry after 30 seconds
        return;
      }
      const text = await response.text();
      if (response.status === 200 && text.toLowerCase().includes("alive")) {
        this.setState({ siteStatus: "Up" });
      }
      if (response.status === 400) {
        this.setState({ siteStatus: "Pending" });
        this.DBAliveTimeout = setTimeout(this.DBAlive, 20000);  // Retry after 20 seconds
      }
    } catch {
      this.setState({ siteStatus: "Down" });
      this.DBAliveTimeout = setTimeout(this.DBAlive, 60000);  // Retry after 60 seconds
    }
  };

  onSearchInputChange = (position) => {
    // console.log(`App - Search input changed: position=${position}`);
    if (position === 'left') {
      this.setState({ leftIDSelected: null }, () => {
        this.setMatchButton();
      });
    } else if (position === 'right') {
      this.setState({ rightIDSelected: null }, () => {
        this.setMatchButton();
      });
    }
  }

  onSearchInputSelected = (position, selectedPersonID, selectedPersonName) => {
    // console.log(`App - Search input selected: position=${position}, selectedPersonID=${selectedPersonID}`);
    
    if (position === 'left') {
      this.setState({ leftIDSelected: selectedPersonID, leftNameSelected: selectedPersonName }, () => {
        this.setMatchButton();
      });
    } else if (position === 'right') {
      this.setState({ rightIDSelected: selectedPersonID, rightNameSelected: selectedPersonName }, () => {
        this.setMatchButton();
      });
    }

    this.unRenderMatchList();
  };

  setMatchButton = () => {
    // console.log('App = setMatchButton called');
    if (this.state.leftIDSelected !== null && this.state.rightIDSelected !== null) {
      this.setState({ matchButtonActive: true });
    } else {
      this.setState({ matchButtonActive: false });
    }
  };

  renderMatchList = () => {
    if (this.state.matchList !== {}) {
      this.setState({ displayMatchList: true });
    }
    else {
      this.setState({ displayMatchList: false });
    }
  }

  renderSameMovieList = () => {
    if (this.state.sameMovieList !== {}) {
      this.setState({ displaySameMovieList: true });
    }
  }

  unRenderMatchList = () => {
    this.setState(
      { 
        displayMatchList: false,
        matchList: {}
      }
    );
  }

  handleMatchButtonClick = () => {
    this.setState({ showFireworks: true, showHuh: false, displayMatchList: false, matchList: [], displaySameMovieList: false, sameMovieList: [] });

    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/samemovielist?Actor1ID=${this.state.leftIDSelected}&Actor2ID=${this.state.rightIDSelected}`)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      // .then(text => JSON.parse(text.replace(/[\x00-\x1F\x7F]/g, ' '))) // Removed because this is taken care of in API now
      .then(text => JSON.parse(text))
      .then((data) => {
        if (data && data.length > 0) {
          this.setState({ sameMovieList: data, showFireworks: false, displaySameMovieList: true, displayMatchList: false });
        } else {
          const fetchString = `${process.env.REACT_APP_API_BASE_URL}/api/connectionsbyactors?Actor1ID=${this.state.leftIDSelected}&Actor2ID=${this.state.rightIDSelected}`;
          const minDelay = new Promise(resolve => setTimeout(resolve, 2000)); // Render the .gif for at least 2 seconds
          const apiFetch = fetch(fetchString).then(response => response.json());

          Promise.all([apiFetch, minDelay])
            .then(([data]) => {
              if (!data || data.length === 0) {
                this.setState({ showFireworks: false, showHuh: true });
              } else {
                this.setState({ matchList: data, showFireworks: false, displayMatchList: true });
              }
            })
            .catch(() => {
              this.setState({ showFireworks: false, showHuh: true });
            });
        }
      })
      .catch(() => {
        this.setState({ showFireworks: false, showHuh: true });
      });
  }

  render() {
    return (
      <div className="App">
        <header className="app-header">
          <h1 className="app-title">Actor Links</h1>
          <button
            className="tagline-toggle"
            onClick={() => this.setState(s => ({ showTagline: !s.showTagline }))}
            aria-expanded={this.state.showTagline}
          >
            {this.state.showTagline ? 'Hide' : 'What is this?'}
          </button>
          <p className={`app-tagline${this.state.showTagline ? '' : ' app-tagline--hidden'}`}>
            Every actor in Hollywood is just a few movies away from every other &mdash; or so the legend goes.
            Pick two stars, hit <em>Match</em>, and watch us untangle the glittering web of films that secretly
            connects them. Think of it as Six Degrees of Kevin Bacon&hellip; but for <em>any</em> two actors you dare to choose.
          </p>
          <div className="app-stats">
            <span className="app-stat">
              <span className="app-stat-number">180,000+</span>
              <span className="app-stat-label">movies</span>
            </span>
            {/* <span className="app-stat-divider">&bull;</span> */}
            <span className="app-stat">
              <span className="app-stat-number">720,000+</span>
              <span className="app-stat-label">actors</span>
            </span>
            {/* <span className="app-stat-divider">&bull;</span> */}
            <span className="app-stat">
              <span className="app-stat-number">Every movie released in the US</span>
              <span className="app-stat-label">in English or Esperanto, since 1930</span>
            </span>
          </div>
        </header>
        <section className="search-inputs-container">
          <SearchInput className="left-search-input"
                       position="left"
                       onSearchInputSelected={this.onSearchInputSelected}
                       onSearchInputChange={this.onSearchInputChange} 
                       siteStatus={this.state.siteStatus} />
          <MatchButton active={this.state.matchButtonActive} 
                       onClick={this.handleMatchButtonClick} />
          <SearchInput position="right"
                       onSearchInputSelected={this.onSearchInputSelected}
                       onSearchInputChange={this.onSearchInputChange} 
                       siteStatus={this.state.siteStatus} />
        </section>
        <div className="match-list-container">
          {this.state.showFireworks
            ? <div className="fireworks-container">
                <img src={fireworks} alt="Loading..." className="fireworks-img" />
                <p className="fireworks-text">
                  Searching for links between {this.state.leftNameSelected} and {this.state.rightNameSelected}...
                  <p className="fireworks-subtext">This can take up to a minute, please be patient!</p>
                </p>
              </div>
            : this.state.showHuh
              ? <img src={huh} alt="No results found" className="huh-img" />
              : <MatchListContainer displayMatchList={this.state.displayMatchList}
                                    matchList={this.state.matchList} 
                                    displaySameMovieList={this.state.displaySameMovieList}
                                    sameMovieList={this.state.sameMovieList} />
          }
        </div>
        <footer className="app-footer">
          <div className="status-indicator-container">
            <UpDownIndicator siteStatus={this.state.siteStatus} />
          </div>
          <p>&copy; 2026 Brian Thompson</p>
        </footer>
      </div>
    );
  };
  componentDidMount = () => {
    this.DBAlive();
  }
  componentWillUnmount = () => {
    clearTimeout(this.DBAliveTimeout);
  }

};

export default App;
